import React from "react";
import i18n from "i18n";
import {
  Button,
  CircularProgress,
  DialogContent,
  Grid,
  Typography,
  withStyles,
} from "@material-ui/core";

const styles = () => ({
  text: {
    fontWeight: 700,
    textTransform: "uppercase" as any,
    marginTop: "1.5rem",
  },
  progress: {
    margin: 0,
    color: "#ABC200",
    width: "5rem !important",
    height: "5rem !important",
  },
});

/** Componenete layer de Carregando da janela de exibir
 * ocorrências de um item da EAP.
 */
const LoadingLayer = ({ classes, onCancel }) => {
  return (
    <DialogContent data-testid="dialogContent-ItemOccurrencesLoadingLayer">
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="center"
        style={{ width: "100%", height: "100%" }}
      >
        <CircularProgress
          className={classes.progress}
          variant="indeterminate"
        />
        <Typography className={classes.text}>
          {i18n.wbs.itemOccurrences.loadingMessage}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={onCancel}
          style={{ marginTop: "2rem" }}
        >
          {i18n.cancel}
        </Button>
      </Grid>
    </DialogContent>
  );
};

export default withStyles(styles)(LoadingLayer);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/DialogItemOccurrences/LoadingLayer.tsx